export enum SocialMediaPlatform {
    INSTAGRAM = 'instagram',
    FACEBOOK = 'facebook',
    TWITTER = 'twitter',
    LINKEDIN = 'linkedin',
    TIKTOK = 'tiktok',
    SNAPCHAT = 'snapchat',
    NONE = 'none',
}

/**
 * Detects if the user is browsing from within a social media platform's webview
 * @returns The detected social media platform or NONE if not detected
 */
export function detectSocialMediaWebView(): SocialMediaPlatform {
    if (typeof window === 'undefined') {
        return SocialMediaPlatform.NONE
    }

    const userAgent = navigator.userAgent || navigator.vendor

    // Instagram webview detection
    if (/Instagram/i.test(userAgent)) {
        return SocialMediaPlatform.INSTAGRAM
    }

    // Facebook webview detection (also covers Instagram since it uses Facebook's webview)
    if (/FBAN|FBAV/i.test(userAgent)) {
        return SocialMediaPlatform.FACEBOOK
    }

    // Twitter webview detection
    if (/TwitterAndroid|Twitter for iPhone/i.test(userAgent)) {
        return SocialMediaPlatform.TWITTER
    }

    // LinkedIn webview detection
    if (/LinkedInApp/i.test(userAgent)) {
        return SocialMediaPlatform.LINKEDIN
    }

    // TikTok webview detection
    if (/TikTok/i.test(userAgent)) {
        return SocialMediaPlatform.TIKTOK
    }

    // Snapchat webview detection
    if (/Snapchat/i.test(userAgent)) {
        return SocialMediaPlatform.SNAPCHAT
    }

    return SocialMediaPlatform.NONE
}

/**
 * Checks if the current webview is from Instagram specifically
 * @returns true if browsing from Instagram webview
 */
export function isInstagramWebView(): boolean {
    return detectSocialMediaWebView() === SocialMediaPlatform.INSTAGRAM
}

/**
 * Checks if the user is browsing from within any social media webview
 * @returns true if browsing from any social media webview
 */
export function isSocialMediaWebView(): boolean {
    return detectSocialMediaWebView() !== SocialMediaPlatform.NONE
}
